import { createFileRoute, notFound } from '@tanstack/react-router';
import { SettingsPage } from '../../../../pages/settings/Settings';
import { getMeQueryOptions } from '../../../../rest-api/queries/sharedQueries';
import { isOwnerRole } from '../../../../utils/isOwnerRole';

export const Route = createFileRoute('/_private/_home/settings')({
  // Settings is owner-only. Previously the whole subtree was simply not mounted
  // for other roles, so they fell through to the '*' PageNotFound route —
  // notFound() reproduces that exact behavior.
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(getMeQueryOptions(context.apiClient));
    if (!isOwnerRole(me.role)) {
      throw notFound();
    }
  },
  component: SettingsPage,
});
